(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5352,7357],{

/***/ 15611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/api/routes/goodDataBetterMarketing/queries/index.ts + 2 modules
var queries = __webpack_require__(19890);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ./src/views/GoodDataBetterMarketing/components/LearnFromVeryBest/LearnFromVeryBest.tsx
var LearnFromVeryBest = __webpack_require__(36590);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableOfContents/index.ts + 8 modules
var TableOfContents = __webpack_require__(55979);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/components/Sidebar/Sidebar.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var Sidebar = function Sidebar(_ref) {
  var id = _ref.id,
      data = _ref.data;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "lg",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toc, {
        data: data
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "lg",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSelect, {
        id: id,
        data: data
      })
    })]
  });
};

var Toc = function Toc(_ref2) {
  var data = _ref2.data;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TableOfContents/* default */.ZP, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* Title */.Dx, {
      children: "On this page"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* List */.aV, {
      children: data.map(function (item) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContentsItem, {
          slug: item.value,
          text: item.text
        }, item.value);
      })
    })]
  });
};

var MobileSelect = function MobileSelect(_ref3) {
  var id = _ref3.id,
      data = _ref3.data;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useSelect = (0,useSelect/* default */.Z)({
    options: data,
    id: id,
    onSelect: function onSelect(e) {
      var _e$;

      (0,useScrollToAnchor/* scrollToAnchor */.d)((_e$ = e[0]) === null || _e$ === void 0 ? void 0 : _e$.value, -100);
    },
    config: {
      mobileConfirmationBehaviour: false
    },
    label: "Select a section"
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      name: id,
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {
        color: theme.palette.brand.darkAcai[700]
      })
    }, getControlProps({
      placeholder: "On this page"
    }))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, _objectSpread({
      id: "select-base-".concat(id),
      name: "select-base-".concat(id),
      options: data,
      filteredOptions: filteredOptions,
      displayMode: state.displayMode,
      open: state.open,
      modalHeadline: "On this page"
    }, getSelectProps()))]
  });
};

var TableOfContentsItem = function TableOfContentsItem(_ref4) {
  var slug = _ref4.slug,
      text = _ref4.text;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* ListItem */.HC, {
    borderDirection: "bottom",
    href: "#".concat(slug),
    onClick: function onClick(e) {
      e.preventDefault();
      (0,useScrollToAnchor/* scrollToAnchor */.d)(slug, -100);
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* LeftContent */.PJ, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* Text */.xv, {
        variant: "pMedium",
        children: text
      })
    })
  });
};

/* harmony default export */ var Sidebar_Sidebar = (Sidebar);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
;// CONCATENATED MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/components/ArticleContent/ArticleContent.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var ArticleContent = function ArticleContent(_ref) {
  var sections = _ref.sections;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: sections.map(function (section) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleSection, {
        section: section
      }, section.id);
    })
  });
};

/* harmony default export */ var ArticleContent_ArticleContent = (ArticleContent);

var ArticleSection = function ArticleSection(_ref2) {
  var section = _ref2.section;
  var options = (0,react.useMemo)(function () {
    var _renderNode;

    return {
      renderNode: (_renderNode = {}, (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.UL_LIST, function (_, children) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.PARAGRAPH, function (_, children) {
        var _defaultOptions$rende;

        switch (section.id) {
          case "resources-and-links":
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph, {
              variant: "pLarge",
              tag: "p",
              children: children
            });

          case "episode-timestamps":
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* ColoredTypography */.nq, {
              variant: "pMedium",
              tag: "p",
              children: children
            });

          default:
            return RichText/* defaultOptions */.vC === null || RichText/* defaultOptions */.vC === void 0 ? void 0 : (_defaultOptions$rende = RichText/* defaultOptions.renderNode */.vC.renderNode) === null || _defaultOptions$rende === void 0 ? void 0 : _defaultOptions$rende[dist.BLOCKS.PARAGRAPH](_, children);
        }
      }), _renderNode)
    };
  }, [section.id]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
      variant: "h2",
      tag: "h2",
      id: section.id,
      children: section.heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
      data: section.content,
      options: options
    })]
  }, section.heading);
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "e159thk62"
} : 0)("display:grid;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{gap:32px;}" + ( true ? "" : 0));

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e159thk61"
} : 0)("display:grid;gap:16px;padding-left:27px;color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.brand.darkAcai[500];
}, ";" + ( true ? "" : 0));

var Paragraph = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RichText/* ColoredTypography */.nq,  true ? {
  target: "e159thk60"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
;// CONCATENATED MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/components/Transcript/Transcript.tsx







var Transcript = function Transcript(_ref) {
  var heading = _ref.heading,
      id = _ref.id,
      content = _ref.content;

  var _useActiveState = (0,useActiveState/* useActiveState */.z)([false]),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Transcript_Wrapper, {
    children: activeItems.map(function (active, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
          onClick: function onClick() {
            return toggle(index);
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
              variant: "h2",
              opened: active,
              id: id,
              children: heading
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
            opened: active
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
          children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Text */.xv, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
                data: content
              })
            })
          })
        })]
      }, "item-".concat(index));
    })
  });
};

/* harmony default export */ var Transcript_Transcript = (Transcript);

var Transcript_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e12xov660"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/components/RecentEpisodes/RecentEpisodes.tsx


function RecentEpisodes_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var copy = {
  heading: "Recent episodes"
};

var RecentEpisodes = function RecentEpisodes(_ref) {
  var episodeSlug = _ref.episodeSlug;

  var _useRecentEpisodeQuer = (0,queries/* useRecentEpisodeQuery */.Oh)({
    args: [episodeSlug]
  }),
      data = _useRecentEpisodeQuer.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "light",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextBase, {
          centered: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: copy.heading
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          columns: 1,
          overrides: {
            md: 2,
            xl: 3
          },
          children: data && data.map(function (_ref2) {
            var fields = _ref2.fields;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Episode, {
              title: fields.episodeTitle,
              description: fields.episodeDescription,
              slug: fields.slug,
              image: fields.episodeImage
            }, fields.slug);
          })
        })]
      })
    })
  });
};

var Episode = function Episode(_ref3) {
  var _image$fields$file$de, _image$fields$file$de2;

  var title = _ref3.title,
      description = _ref3.description,
      slug = _ref3.slug,
      image = _ref3.image;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var data = (0,react.useMemo)(function () {
    return {
      title: title,
      description: description,
      href: (0,getAbsoluteUrl/* default */.Z)("/good-data-better-marketing/".concat(slug, "/"), pageConfig),
      image: image
    };
  }, [pageConfig, title, description, slug, image]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* default */.ZP, {
    href: data.href,
    layout: "vertical",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Image */.Ee, {
      variant: "fill",
      alt: image.fields.title,
      src: image.fields.file.url,
      width: (_image$fields$file$de = image.fields.file.details.image) === null || _image$fields$file$de === void 0 ? void 0 : _image$fields$file$de.width,
      height: (_image$fields$file$de2 = image.fields.file.details.image) === null || _image$fields$file$de2 === void 0 ? void 0 : _image$fields$file$de2.height
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
          tag: "h3",
          children: data.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
          variant: "pLarge",
          children: data.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
        alignment: "right",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
      })]
    })]
  });
};

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "ea06ccg0"
} : 0)( true ? {
  name: "176y9tq",
  styles: "padding-bottom:56px"
} : 0);

/* harmony default export */ var RecentEpisodes_RecentEpisodes = (RecentEpisodes);
;// CONCATENATED MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/components/EpisodePlayers/assets/ApplePodcastsBadge.svg
var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgApplePodcastsBadge = function SvgApplePodcastsBadge(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 160 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#ApplePodcastsBadge_svg__clip0_413_66144)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M152.5.832H7.5a7 7 0 0 0-7 7v25a7 7 0 0 0 7 7h145a7 7 0 0 0 7-7v-25a7 7 0 0 0-7-7Z",
    fill: "#fff",
    stroke: "#CACDD8"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.213 28.705c-.235.597-.778 1.439-1.548 2.031-.444.342-.974.67-1.703.885-.777.23-1.734.308-2.924.308H16.15c-1.19 0-2.148-.078-2.924-.308a5.068 5.068 0 0 1-1.704-.885c-.77-.593-1.312-1.434-1.547-2.031-.474-1.204-.479-2.57-.479-3.43V14.389c0-.86.005-2.226.479-3.43.235-.597.777-1.438 1.547-2.03.444-.343.975-.67 1.704-.886.776-.23 1.733-.308 2.924-.308h10.888c1.19 0 2.147.078 2.924.308a5.07 5.07 0 0 1 1.703.885c.77.593 1.313 1.434 1.548 2.031.474 1.204.478 2.57.478 3.43v10.888c0 .86-.004 2.225-.478 3.429Z",
    fill: "url(#ApplePodcastsBadge_svg__paint0_linear_413_66144)"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.348 21.64c-.363-.382-1-.628-1.754-.628-.753 0-1.39.246-1.753.629-.19.2-.29.405-.322.697-.06.565-.026 1.052.04 1.83.063.741.183 1.73.34 2.737.11.717.2 1.104.283 1.38.134.45.632.842 1.412.842.78 0 1.279-.392 1.412-.841.083-.277.173-.664.284-1.38.157-1.008.277-1.997.34-2.738.066-.778.1-1.265.039-1.83a1.112 1.112 0 0 0-.321-.697Zm-3.732-3.41a1.98 1.98 0 1 0 3.96 0 1.98 1.98 0 0 0-3.96 0Zm1.956-7.814c-4.631.013-8.426 3.77-8.483 8.4-.047 3.752 2.348 6.96 5.691 8.137a.114.114 0 0 0 .151-.124 48.28 48.28 0 0 1-.123-.872.293.293 0 0 0-.172-.23 7.43 7.43 0 0 1-4.459-6.876c.039-4.03 3.33-7.314 7.358-7.346 4.12-.034 7.481 3.307 7.481 7.419a7.43 7.43 0 0 1-4.46 6.803.293.293 0 0 0-.171.23c-.038.288-.08.58-.123.872a.114.114 0 0 0 .15.124c3.312-1.165 5.693-4.324 5.693-8.029 0-4.7-3.83-8.522-8.533-8.508Zm-.154 3.903a4.616 4.616 0 0 1 4.793 4.608c0 1.323-.56 2.519-1.457 3.36a.353.353 0 0 0-.111.277 8.16 8.16 0 0 1-.01.972.112.112 0 0 0 .175.1 5.698 5.698 0 0 0 2.492-4.71 5.706 5.706 0 0 0-5.925-5.695c-3.016.117-5.436 2.603-5.474 5.621a5.697 5.697 0 0 0 2.492 4.784.112.112 0 0 0 .174-.1 8.165 8.165 0 0 1-.01-.972.353.353 0 0 0-.11-.276 4.599 4.599 0 0 1-1.456-3.485 4.624 4.624 0 0 1 4.427-4.484Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M43 15.228V9.436h.91v5.027h2.758v.765H43Zm5.009-4.898c-.282 0-.528-.217-.528-.495 0-.277.246-.503.528-.503.291 0 .528.226.528.503 0 .278-.237.495-.528.495Zm-.4 4.898v-4.194h.818v4.194h-.819Zm1.695-.547.391-.573c.3.312.883.599 1.475.599.619 0 .946-.244.946-.6 0-.416-.5-.555-1.065-.677-.746-.165-1.62-.356-1.62-1.259 0-.668.601-1.241 1.675-1.241.755 0 1.302.26 1.675.599l-.364.547c-.255-.296-.747-.513-1.302-.513s-.9.209-.9.547c0 .365.472.487 1.018.608.765.165 1.675.365 1.675 1.329 0 .72-.619 1.285-1.775 1.285-.737 0-1.383-.217-1.83-.651Zm5.81.65c-.692 0-1.047-.373-1.047-1.032v-2.58h-.728v-.685h.728V9.887h.819v1.147h.892v.686h-.892v2.405c0 .295.146.512.428.512a.647.647 0 0 0 .446-.165l.21.59c-.174.157-.429.27-.856.27Zm1.258-2.205c0-1.215.92-2.196 2.203-2.196 1.32 0 2.139.98 2.139 2.266v.19h-3.477c.064.713.61 1.303 1.493 1.303.464 0 .974-.173 1.301-.495l.383.513c-.437.408-1.056.625-1.766.625-1.31 0-2.276-.886-2.276-2.206Zm2.203-1.554c-.883 0-1.302.677-1.347 1.25h2.685c-.018-.555-.41-1.25-1.338-1.25Zm6.092 3.656v-2.684c0-.694-.373-.92-.938-.92-.51 0-.974.295-1.21.608v2.996h-.82v-4.194h.82v.59a2.136 2.136 0 0 1 1.556-.694c.929 0 1.411.468 1.411 1.354v2.944h-.82Zm6.331.104c-1.365 0-2.22-.99-2.22-2.206 0-1.207.855-2.196 2.22-2.196 1.374 0 2.22.99 2.22 2.196 0 1.216-.846 2.206-2.22 2.206Zm0-.695c.883 0 1.365-.712 1.365-1.51 0-.79-.482-1.503-1.365-1.503-.874 0-1.365.712-1.365 1.502 0 .8.491 1.511 1.365 1.511Zm6.183.59v-2.683c0-.694-.373-.92-.938-.92-.51 0-.974.295-1.21.608v2.996h-.82v-4.194h.82v.59a2.136 2.136 0 0 1 1.556-.694c.929 0 1.411.468 1.411 1.354v2.944h-.82ZM45.023 31.332l1.032-3.047h4.297l1.03 3.047h1.852l-4.07-11.274h-1.89l-4.07 11.274h1.82Zm4.883-4.453H46.5l1.68-4.946h.047l1.68 4.946Zm6.055 7.171v-4.07H56c.469.914 1.406 1.492 2.586 1.492 2.062 0 3.43-1.648 3.43-4.25 0-2.601-1.375-4.242-3.461-4.242-1.188 0-2.133.602-2.617 1.547h-.032v-1.414h-1.633v10.938h1.688Zm2.148-4.007c-1.297 0-2.156-1.11-2.156-2.82 0-1.696.867-2.82 2.156-2.82 1.336 0 2.172 1.1 2.172 2.82 0 1.726-.836 2.82-2.172 2.82ZM65 34.05v-4.07h.04c.468.913 1.405 1.491 2.585 1.491 2.063 0 3.43-1.648 3.43-4.25 0-2.601-1.375-4.242-3.461-4.242-1.188 0-2.133.602-2.617 1.547h-.032v-1.414h-1.632v10.938H65Zm2.148-4.008c-1.296 0-2.156-1.11-2.156-2.82 0-1.696.867-2.82 2.156-2.82 1.336 0 2.172 1.1 2.172 2.82 0 1.726-.836 2.82-2.172 2.82Zm6.954 1.289V20.058h-1.688v11.274h1.688Zm5.242.156c1.883 0 3.304-1.07 3.539-2.57H81.28c-.226.719-.937 1.203-1.898 1.203-1.352 0-2.211-.945-2.211-2.375v-.102h5.805v-.578c0-2.492-1.422-4.101-3.704-4.101-2.32 0-3.804 1.718-3.804 4.297 0 2.593 1.46 4.226 3.875 4.226Zm1.945-5.023h-4.11c.087-1.243.915-2.141 2.094-2.141 1.18 0 1.977.883 2.016 2.14Zm8.188 4.867V27.48h2.421c2.211 0 3.766-1.515 3.766-3.718 0-2.196-1.523-3.704-3.71-3.704h-4.227v11.274h1.75Zm2.007-5.32h-2.007v-4.477h2.015c1.516 0 2.383.812 2.383 2.234s-.867 2.243-2.39 2.243Zm9.039 5.476c2.352 0 3.899-1.617 3.899-4.266 0-2.64-1.555-4.257-3.899-4.257-2.343 0-3.898 1.617-3.898 4.257 0 2.649 1.547 4.266 3.898 4.266Zm0-1.39c-1.32 0-2.18-1.047-2.18-2.876 0-1.82.86-2.867 2.18-2.867 1.321 0 2.18 1.047 2.18 2.867 0 1.828-.851 2.875-2.18 2.875Zm8.289 1.374c1.196 0 2.133-.601 2.618-1.539h.031v1.399h1.641V20.058h-1.696v4.422h-.031c-.461-.906-1.398-1.5-2.578-1.5-2.063 0-3.438 1.649-3.438 4.242 0 2.594 1.375 4.25 3.453 4.25Zm.446-1.43c-1.336 0-2.172-1.085-2.172-2.82 0-1.726.836-2.82 2.172-2.82 1.297 0 2.164 1.117 2.164 2.82 0 1.72-.867 2.82-2.164 2.82Zm9.086 1.446c1.976 0 3.375-1.188 3.554-2.938h-1.625c-.195.954-.875 1.524-1.914 1.524-1.312 0-2.179-1.047-2.179-2.852 0-1.765.859-2.851 2.164-2.851 1.101 0 1.758.695 1.929 1.57h1.61c-.149-1.617-1.438-2.976-3.555-2.976-2.336 0-3.867 1.648-3.867 4.257 0 2.657 1.531 4.266 3.883 4.266Zm7.156-.016c1.078 0 2.117-.578 2.594-1.492h.039v1.352h1.617v-5.664c0-1.649-1.273-2.703-3.266-2.703-2.031 0-3.296 1.093-3.39 2.578h1.594c.148-.735.757-1.203 1.734-1.203 1.031 0 1.648.547 1.648 1.46v.633l-2.25.133c-1.953.11-3.054.992-3.054 2.43 0 1.476 1.125 2.476 2.734 2.476Zm.469-1.335c-.907 0-1.5-.47-1.5-1.188 0-.703.57-1.149 1.578-1.219l2.023-.125v.649c0 1.07-.922 1.883-2.101 1.883Zm8.5 1.351c1.937 0 3.336-1.031 3.336-2.531 0-1.188-.641-1.844-2.321-2.235l-1.336-.304c-.89-.203-1.265-.555-1.265-1.07 0-.657.609-1.102 1.523-1.102.946 0 1.532.5 1.625 1.297h1.586c-.055-1.516-1.297-2.578-3.211-2.578-1.89 0-3.172 1.007-3.172 2.476 0 1.196.774 1.946 2.336 2.305l1.336.312c.899.204 1.203.516 1.203 1.047 0 .672-.625 1.094-1.64 1.094-1.031 0-1.617-.422-1.774-1.281h-1.672c.157 1.562 1.391 2.57 3.446 2.57Zm7.445-.101c.375 0 .75-.032.938-.079v-1.336c-.11.024-.383.04-.555.04-.688 0-1-.32-1-1.032V24.45h1.562v-1.336h-1.562v-1.945h-1.695v1.945h-1.196v1.336h1.196v4.719c0 1.586.648 2.219 2.312 2.219Zm5.414.101c1.938 0 3.336-1.031 3.336-2.531 0-1.188-.641-1.844-2.32-2.235l-1.336-.304c-.891-.203-1.266-.555-1.266-1.07 0-.657.61-1.102 1.524-1.102.945 0 1.531.5 1.625 1.297h1.586c-.055-1.516-1.297-2.578-3.211-2.578-1.891 0-3.172 1.007-3.172 2.476 0 1.196.773 1.946 2.336 2.305l1.336.312c.898.204 1.203.516 1.203 1.047 0 .672-.625 1.094-1.641 1.094-1.031 0-1.617-.422-1.773-1.281h-1.672c.156 1.562 1.39 2.57 3.445 2.57Z",
    fill: "#394762"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "ApplePodcastsBadge_svg__paint0_linear_413_66144",
    x1: 21.594,
    y1: 7.734,
    x2: 21.594,
    y2: 31.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#F452FF"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#832BC1"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "ApplePodcastsBadge_svg__clip0_413_66144"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .332)",
    d: "M0 0h160v40H0z"
  })))));
};
/* harmony default export */ var ApplePodcastsBadge = (SvgApplePodcastsBadge);
;// CONCATENATED MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/components/EpisodePlayers/assets/GooglePodcastsBadge.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function GooglePodcastsBadge_extends() { GooglePodcastsBadge_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return GooglePodcastsBadge_extends.apply(this, arguments); }

var SvgGooglePodcastsBadge = function SvgGooglePodcastsBadge(props) {
  return /*#__PURE__*/react.createElement("svg", GooglePodcastsBadge_extends({
    viewBox: "0 0 160 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M152.5.832H7.5a7 7 0 0 0-7 7v25a7 7 0 0 0 7 7h145a7 7 0 0 0 7-7v-25a7 7 0 0 0-7-7Z",
    fill: "#fff",
    stroke: "#CACDD8"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M43 15.228V9.436h.91v5.027h2.758v.765H43Zm5.009-4.898c-.282 0-.528-.217-.528-.495 0-.277.246-.503.528-.503.291 0 .528.226.528.503 0 .278-.237.495-.528.495Zm-.4 4.898v-4.194h.818v4.194h-.819Zm1.695-.547.391-.573c.3.312.883.599 1.475.599.619 0 .946-.244.946-.6 0-.416-.5-.555-1.065-.677-.746-.165-1.62-.356-1.62-1.259 0-.668.601-1.241 1.675-1.241.755 0 1.302.26 1.675.599l-.364.547c-.255-.296-.747-.513-1.302-.513s-.9.209-.9.547c0 .365.472.487 1.018.608.765.165 1.675.365 1.675 1.329 0 .72-.619 1.285-1.775 1.285-.737 0-1.383-.217-1.83-.651Zm5.81.65c-.692 0-1.047-.373-1.047-1.032v-2.58h-.728v-.685h.728V9.887h.819v1.147h.892v.686h-.892v2.405c0 .295.146.512.428.512a.647.647 0 0 0 .446-.165l.21.59c-.174.157-.429.27-.856.27Zm1.258-2.205c0-1.215.92-2.196 2.203-2.196 1.32 0 2.139.98 2.139 2.266v.19h-3.477c.064.713.61 1.303 1.493 1.303.464 0 .974-.173 1.301-.495l.383.513c-.437.408-1.056.625-1.766.625-1.31 0-2.276-.886-2.276-2.206Zm2.203-1.554c-.883 0-1.302.677-1.347 1.25h2.685c-.018-.555-.41-1.25-1.338-1.25Zm6.092 3.656v-2.684c0-.694-.373-.92-.938-.92-.51 0-.974.295-1.21.608v2.996h-.82v-4.194h.82v.59a2.136 2.136 0 0 1 1.556-.694c.929 0 1.411.468 1.411 1.354v2.944h-.82Zm6.331.104c-1.365 0-2.22-.99-2.22-2.206 0-1.207.855-2.196 2.22-2.196 1.374 0 2.22.99 2.22 2.196 0 1.216-.846 2.206-2.22 2.206Zm0-.695c.883 0 1.365-.712 1.365-1.51 0-.79-.482-1.503-1.365-1.503-.874 0-1.365.712-1.365 1.502 0 .8.491 1.511 1.365 1.511Zm6.183.59v-2.683c0-.694-.373-.92-.938-.92-.51 0-.974.295-1.21.608v2.996h-.82v-4.194h.82v.59a2.136 2.136 0 0 1 1.556-.694c.929 0 1.411.468 1.411 1.354v2.944h-.82Z",
    fill: "#394762"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.938 15.286v9.091h3.125v-9.091h-3.125Z",
    fill: "#FAB908"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M11.563 20.542a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125Z",
    fill: "#0066D9"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M11.563 22.247a1.563 1.563 0 1 0 0-3.126 1.563 1.563 0 0 0 0 3.126Z",
    fill: "#0066D9"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M13.125 18.98H10v1.704h3.125V18.98Z",
    fill: "#0066D9"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M33.438 22.247a1.563 1.563 0 1 0 0-3.126 1.563 1.563 0 0 0 0 3.126Z",
    fill: "#4285F4"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M33.438 20.542a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125Z",
    fill: "#4285F4"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M31.875 20.684H35V18.98h-3.125v1.704Z",
    fill: "#4285F4"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M16.96 25.656a1.562 1.562 0 1 0 .001-3.125 1.562 1.562 0 0 0 0 3.125Z",
    fill: "#EA4335"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M16.96 27.36a1.562 1.562 0 1 0 .001-3.125 1.562 1.562 0 0 0 0 3.125Z",
    fill: "#EA4335"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M18.523 24.093h-3.125v1.705h3.125v-1.705ZM16.96 15.428a1.562 1.562 0 1 0 .001-3.125 1.562 1.562 0 0 0 0 3.125ZM16.96 20.968a1.562 1.562 0 1 0 .001-3.125 1.562 1.562 0 0 0 0 3.125Z",
    fill: "#EA4335"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M18.523 13.866h-3.125v5.575h3.125v-5.575Z",
    fill: "#EA4335"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M28.04 17.133a1.562 1.562 0 1 0 0-3.125 1.562 1.562 0 0 0 0 3.125Z",
    fill: "#34A853"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M28.04 15.428a1.562 1.562 0 1 0 0-3.125 1.562 1.562 0 0 0 0 3.125Z",
    fill: "#34A853"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M26.477 15.57h3.125v-1.704h-3.125v1.704Z",
    fill: "#34A853"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M22.5 12.161a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125Z",
    fill: "#FAB908"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M22.5 10.457a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125Z",
    fill: "#FAB908"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M20.938 10.599h3.125V8.894h-3.125V10.6ZM22.5 32.332a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125Z",
    fill: "#FAB908"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M22.5 30.627a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125Z",
    fill: "#FAB908"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M20.938 30.77h3.125v-1.705h-3.125v1.704Z",
    fill: "#FAB908"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M28.04 27.36a1.562 1.562 0 1 0 0-3.125 1.562 1.562 0 0 0 0 3.125ZM28.04 21.82a1.562 1.562 0 1 0 0-3.125 1.562 1.562 0 0 0 0 3.125Z",
    fill: "#34A853"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "M26.477 25.798h3.125v-5.54h-3.125v5.54Z",
    fill: "#34A853"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "M22.5 16.849a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125ZM22.5 25.94a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125Z",
    fill: "#FAB908"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "M47.523 31.508c2.864 0 4.556-1.707 4.556-4.57V25.86h-4.351v1.325h2.732v.183c-.022 1.604-1.209 2.703-2.922 2.703-2.015 0-3.267-1.56-3.267-4.087 0-2.483 1.216-3.962 3.237-3.962 1.377 0 2.41.754 2.805 2.065h1.685c-.366-2.11-2.146-3.5-4.497-3.5-3.01 0-4.907 2.08-4.907 5.412 0 3.39 1.904 5.508 4.929 5.508Zm9.28-.03c2.204 0 3.655-1.516 3.655-3.999 0-2.475-1.458-3.991-3.655-3.991s-3.655 1.516-3.655 3.991c0 2.483 1.45 4 3.655 4Zm0-1.303c-1.238 0-2.044-.982-2.044-2.696 0-1.706.806-2.688 2.044-2.688s2.043.982 2.043 2.688c0 1.714-.798 2.696-2.043 2.696Zm8.188 1.303c2.205 0 3.655-1.516 3.655-3.999 0-2.475-1.457-3.991-3.655-3.991-2.197 0-3.655 1.516-3.655 3.991 0 2.483 1.45 4 3.655 4Zm0-1.303c-1.238 0-2.043-.982-2.043-2.696 0-1.706.805-2.688 2.043-2.688s2.044.982 2.044 2.688c0 1.714-.799 2.696-2.044 2.696Zm8.174 4.057c2.197 0 3.618-1.201 3.618-3.04v-7.565h-1.538v1.318h-.03c-.468-.893-1.362-1.443-2.453-1.443-1.977 0-3.237 1.524-3.237 3.948 0 2.402 1.267 3.911 3.2 3.911 1.1 0 2.007-.55 2.44-1.384h.029v1.267c0 1.055-.733 1.758-1.97 1.758-.901 0-1.604-.425-1.831-1.07h-1.59c.198 1.333 1.546 2.3 3.362 2.3Zm-.015-4.182c-1.215 0-2.006-.981-2.006-2.593 0-1.604.79-2.622 2.006-2.622 1.238 0 2.051 1.04 2.051 2.622 0 1.59-.813 2.593-2.05 2.593Zm6.834 1.282v-10.57h-1.582v10.57h1.582Zm4.914.146c1.766 0 3.099-1.003 3.318-2.41h-1.501c-.213.674-.88 1.128-1.78 1.128-1.267 0-2.073-.886-2.073-2.226v-.095h5.442v-.542c0-2.337-1.333-3.845-3.472-3.845-2.175 0-3.566 1.61-3.566 4.028 0 2.432 1.37 3.962 3.632 3.962Zm1.824-4.71H82.87c.08-1.164.857-2.006 1.962-2.006 1.107 0 1.854.828 1.89 2.007Zm7.676 4.564V27.72h2.27c2.073 0 3.531-1.421 3.531-3.486 0-2.058-1.428-3.472-3.48-3.472h-3.962v10.569h1.64Zm1.882-4.988h-1.882v-4.197h1.89c1.42 0 2.234.762 2.234 2.095 0 1.333-.814 2.102-2.242 2.102Zm8.474 5.134c2.205 0 3.655-1.516 3.655-3.999 0-2.475-1.457-3.991-3.655-3.991-2.197 0-3.654 1.516-3.654 3.991 0 2.483 1.45 4 3.654 4Zm0-1.303c-1.237 0-2.043-.982-2.043-2.696 0-1.706.806-2.688 2.043-2.688 1.238 0 2.044.982 2.044 2.688 0 1.714-.798 2.696-2.044 2.696Zm7.771 1.289c1.121 0 2-.564 2.454-1.443h.029v1.31h1.538V20.764h-1.589v4.145h-.029c-.432-.85-1.311-1.406-2.417-1.406-1.934 0-3.223 1.546-3.223 3.977 0 2.432 1.289 3.985 3.237 3.985Zm.418-1.34c-1.253 0-2.036-1.019-2.036-2.645 0-1.618.783-2.644 2.036-2.644 1.216 0 2.029 1.048 2.029 2.644 0 1.612-.813 2.644-2.029 2.644Zm8.518 1.354c1.853 0 3.164-1.113 3.332-2.754h-1.523c-.183.894-.82 1.429-1.794 1.429-1.231 0-2.044-.982-2.044-2.674 0-1.655.806-2.673 2.029-2.673 1.033 0 1.648.652 1.809 1.472h1.509c-.139-1.516-1.348-2.79-3.333-2.79-2.19 0-3.625 1.545-3.625 3.991 0 2.49 1.435 4 3.64 4Zm6.709-.014c1.011 0 1.985-.542 2.432-1.4h.036v1.268h1.516v-5.31c0-1.546-1.194-2.534-3.061-2.534-1.905 0-3.091 1.025-3.179 2.416h1.494c.139-.688.711-1.127 1.626-1.127.967 0 1.546.512 1.546 1.37v.593l-2.11.124c-1.831.103-2.864.93-2.864 2.278 0 1.384 1.055 2.322 2.564 2.322Zm.439-1.253c-.849 0-1.406-.44-1.406-1.113 0-.66.535-1.077 1.48-1.143l1.897-.117v.608c0 1.003-.865 1.765-1.971 1.765Zm7.969 1.267c1.817 0 3.128-.966 3.128-2.373 0-1.113-.601-1.728-2.176-2.095l-1.252-.285c-.835-.19-1.187-.52-1.187-1.004 0-.615.572-1.032 1.429-1.032.886 0 1.435.468 1.523 1.215h1.487c-.051-1.42-1.216-2.416-3.01-2.416-1.773 0-2.974.944-2.974 2.321 0 1.12.725 1.824 2.19 2.161l1.252.293c.843.19 1.128.483 1.128.981 0 .63-.586 1.026-1.538 1.026-.967 0-1.516-.396-1.662-1.201h-1.568c.147 1.464 1.304 2.41 3.23 2.41Zm6.98-.095c.352 0 .703-.03.879-.073v-1.253a3.477 3.477 0 0 1-.52.037c-.645 0-.938-.3-.938-.967V24.88h1.465v-1.252h-1.465v-1.824h-1.589v1.824h-1.12v1.252h1.12v4.424c0 1.487.608 2.08 2.168 2.08Zm5.076.095c1.816 0 3.127-.966 3.127-2.373 0-1.113-.6-1.728-2.175-2.095l-1.253-.285c-.834-.19-1.186-.52-1.186-1.004 0-.615.571-1.032 1.428-1.032.886 0 1.436.468 1.524 1.215h1.486c-.051-1.42-1.215-2.416-3.01-2.416-1.772 0-2.973.944-2.973 2.321 0 1.12.725 1.824 2.19 2.161l1.252.293c.842.19 1.128.483 1.128.981 0 .63-.586 1.026-1.538 1.026-.967 0-1.516-.396-1.663-1.201h-1.567c.146 1.464 1.304 2.41 3.23 2.41Z",
    fill: "#394762"
  })));
};
/* harmony default export */ var GooglePodcastsBadge = (SvgGooglePodcastsBadge);
;// CONCATENATED MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/components/EpisodePlayers/assets/SpotifyBadge.svg
var SpotifyBadge_path, SpotifyBadge_path2, SpotifyBadge_path3, SpotifyBadge_path4;
function SpotifyBadge_extends() { SpotifyBadge_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SpotifyBadge_extends.apply(this, arguments); }

var SvgSpotifyBadge = function SvgSpotifyBadge(props) {
  return /*#__PURE__*/react.createElement("svg", SpotifyBadge_extends({
    viewBox: "0 0 160 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), SpotifyBadge_path || (SpotifyBadge_path = /*#__PURE__*/react.createElement("path", {
    d: "M152.5.832H7.5a7 7 0 0 0-7 7v25a7 7 0 0 0 7 7h145a7 7 0 0 0 7-7v-25a7 7 0 0 0-7-7Z",
    fill: "#fff",
    stroke: "#CACDD8"
  })), SpotifyBadge_path2 || (SpotifyBadge_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M43 15.228V9.436h.91v5.027h2.758v.765H43Zm5.009-4.898c-.282 0-.528-.217-.528-.495 0-.277.246-.503.528-.503.291 0 .528.226.528.503 0 .278-.237.495-.528.495Zm-.4 4.898v-4.194h.818v4.194h-.819Zm1.695-.547.391-.573c.3.312.883.599 1.475.599.619 0 .946-.244.946-.6 0-.416-.5-.555-1.065-.677-.746-.165-1.62-.356-1.62-1.259 0-.668.601-1.241 1.675-1.241.755 0 1.302.26 1.675.599l-.364.547c-.255-.296-.747-.513-1.302-.513s-.9.209-.9.547c0 .365.472.487 1.018.608.765.165 1.675.365 1.675 1.329 0 .72-.619 1.285-1.775 1.285-.737 0-1.383-.217-1.83-.651Zm5.81.65c-.692 0-1.047-.373-1.047-1.032v-2.58h-.728v-.685h.728V9.887h.819v1.147h.892v.686h-.892v2.405c0 .295.146.512.428.512a.647.647 0 0 0 .446-.165l.21.59c-.174.157-.429.27-.856.27Zm1.258-2.205c0-1.215.92-2.196 2.203-2.196 1.32 0 2.139.98 2.139 2.266v.19h-3.477c.064.713.61 1.303 1.493 1.303.464 0 .974-.173 1.301-.495l.383.513c-.437.408-1.056.625-1.766.625-1.31 0-2.276-.886-2.276-2.206Zm2.203-1.554c-.883 0-1.302.677-1.347 1.25h2.685c-.018-.555-.41-1.25-1.338-1.25Zm6.092 3.656v-2.684c0-.694-.373-.92-.938-.92-.51 0-.974.295-1.21.608v2.996h-.82v-4.194h.82v.59a2.136 2.136 0 0 1 1.556-.694c.929 0 1.411.468 1.411 1.354v2.944h-.82Zm6.331.104c-1.365 0-2.22-.99-2.22-2.206 0-1.207.855-2.196 2.22-2.196 1.374 0 2.22.99 2.22 2.196 0 1.216-.846 2.206-2.22 2.206Zm0-.695c.883 0 1.365-.712 1.365-1.51 0-.79-.482-1.503-1.365-1.503-.874 0-1.365.712-1.365 1.502 0 .8.491 1.511 1.365 1.511Zm6.183.59v-2.683c0-.694-.373-.92-.938-.92-.51 0-.974.295-1.21.608v2.996h-.82v-4.194h.82v.59a2.136 2.136 0 0 1 1.556-.694c.929 0 1.411.468 1.411 1.354v2.944h-.82Z",
    fill: "#394762"
  })), SpotifyBadge_path3 || (SpotifyBadge_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.894 18.413c-4.03-2.393-10.675-2.613-14.522-1.445a1.169 1.169 0 1 1-.679-2.238c4.416-1.34 11.756-1.081 16.395 1.672a1.17 1.17 0 0 1-1.194 2.011Zm-.132 3.544a.975.975 0 0 1-1.34.321c-3.36-2.064-8.482-2.663-12.456-1.456a.976.976 0 0 1-1.216-.65.976.976 0 0 1 .65-1.215c4.54-1.378 10.183-.71 14.042 1.66a.975.975 0 0 1 .32 1.34Zm-1.53 3.404a.778.778 0 0 1-1.07.26c-2.936-1.795-6.63-2.2-10.982-1.206a.779.779 0 1 1-.346-1.518c4.761-1.089 8.845-.62 12.14 1.393a.78.78 0 0 1 .259 1.071ZM22.5 7.331c-6.903 0-12.5 5.597-12.5 12.5 0 6.905 5.597 12.5 12.5 12.5 6.904 0 12.5-5.595 12.5-12.5 0-6.903-5.596-12.5-12.5-12.5Z",
    fill: "#1ED760"
  })), SpotifyBadge_path4 || (SpotifyBadge_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M47.188 31.531c2.79 0 4.565-1.42 4.565-3.677 0-1.743-1.029-2.748-3.536-3.279l-1.311-.274c-1.553-.332-2.167-.913-2.167-1.785 0-1.095 1.03-1.776 2.432-1.776 1.453 0 2.44.739 2.557 1.942h1.801c-.058-2.091-1.793-3.527-4.333-3.527-2.548 0-4.35 1.41-4.35 3.461 0 1.727 1.088 2.839 3.487 3.345l1.303.274c1.602.349 2.233.93 2.233 1.86 0 1.07-1.087 1.85-2.606 1.85-1.594 0-2.723-.713-2.889-1.9h-1.81c.117 2.133 1.918 3.486 4.624 3.486Zm7.811 2.69v-4.325h.041c.499.97 1.495 1.585 2.748 1.585 2.192 0 3.644-1.751 3.644-4.515 0-2.765-1.46-4.508-3.677-4.508-1.262 0-2.266.64-2.78 1.644h-.034v-1.503h-1.735v11.622H55Zm2.283-4.259c-1.378 0-2.291-1.179-2.291-2.996 0-1.802.921-2.997 2.29-2.997 1.42 0 2.308 1.17 2.308 2.997 0 1.834-.888 2.996-2.307 2.996Zm9.28 1.536c2.499 0 4.142-1.719 4.142-4.532 0-2.806-1.652-4.524-4.142-4.524s-4.142 1.718-4.142 4.524c0 2.813 1.644 4.532 4.142 4.532Zm0-1.478c-1.403 0-2.316-1.112-2.316-3.054 0-1.934.913-3.047 2.316-3.047 1.403 0 2.316 1.113 2.316 3.047 0 1.942-.905 3.054-2.316 3.054Zm8.508 1.37c.399 0 .797-.033.996-.083v-1.42a3.922 3.922 0 0 1-.589.042c-.73 0-1.062-.34-1.062-1.096V24.02h1.66v-1.42h-1.66v-2.067h-1.802V22.6h-1.27v1.42h1.27v5.014c0 1.684.69 2.357 2.457 2.357ZM78.5 21.188a1.03 1.03 0 0 0 1.029-1.03c0-.572-.457-1.028-1.03-1.028-.572 0-1.037.456-1.037 1.029 0 .564.465 1.03 1.038 1.03Zm.896 10.144v-8.733h-1.793v8.733h1.793Zm4.159 0v-7.313h1.743v-1.403h-1.768v-.822c0-.772.365-1.162 1.145-1.162.241 0 .482.017.656.05v-1.328a6.425 6.425 0 0 0-1.004-.083c-1.777 0-2.574.797-2.574 2.49v.855H80.55v1.403h1.203v7.313h1.802Zm4.026 3.254c1.81 0 2.672-.681 3.42-2.798l3.27-9.189h-1.893l-2.208 7.106h-.033l-2.208-7.106h-1.942l3.154 8.741c0 .008-.158.523-.158.54-.273.896-.722 1.245-1.552 1.245-.15 0-.448 0-.58-.033v1.452c.132.025.58.042.73.042Z",
    fill: "#394762"
  })));
};
/* harmony default export */ var SpotifyBadge = (SvgSpotifyBadge);
;// CONCATENATED MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/components/EpisodePlayers/EpisodePlayers.tsx







var EpisodePlayers = function EpisodePlayers(_ref) {
  var simplecastId = _ref.simplecastId,
      applePodcastsUrl = _ref.applePodcastsUrl,
      googlePodcastsUrl = _ref.googlePodcastsUrl,
      spotifyUrl = _ref.spotifyUrl;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EpisodePlayers_Wrapper, {
    children: [simplecastId && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
      width: "100%",
      height: "203",
      frameBorder: "no",
      scrolling: "no",
      seamless: true,
      src: simplecastId,
      title: "Play the featured episode"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BadgesWrapper, {
      children: [applePodcastsUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
        href: applePodcastsUrl,
        target: "_blank",
        title: "Listen on Apple Podcasts",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ApplePodcastsBadge, {})
      }), googlePodcastsUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
        href: googlePodcastsUrl,
        target: "_blank",
        title: "Listen on Google Podcasts",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GooglePodcastsBadge, {})
      }), spotifyUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
        href: spotifyUrl,
        target: "_blank",
        title: "Listen on Spotify",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SpotifyBadge, {})
      })]
    })]
  });
};

/* harmony default export */ var EpisodePlayers_EpisodePlayers = (EpisodePlayers);

var EpisodePlayers_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18kbkqq2"
} : 0)("display:grid;gap:24px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{gap:40px;}" + ( true ? "" : 0));

var BadgesWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18kbkqq1"
} : 0)("display:grid;grid-template-columns:repeat(auto-fit, minmax(143px, 159px));column-gap:9px;row-gap:5px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{gap:17px;row-gap:14px;}" + ( true ? "" : 0));

var Badge = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e18kbkqq0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
;// CONCATENATED MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var backButton = {
  href: "/good-data-better-marketing/",
  text: "Back to episodes"
};

var Hero = function Hero(_ref) {
  var _ref$episodeNumber = _ref.episodeNumber,
      episodeNumber = _ref$episodeNumber === void 0 ? 0 : _ref$episodeNumber,
      episodeTitle = _ref.episodeTitle,
      episodeDescription = _ref.episodeDescription,
      episodeImage = _ref.episodeImage;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var episode = "Episode ".concat(episodeNumber < 10 ? "0".concat(episodeNumber) : episodeNumber);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
            tag: "a",
            href: (0,getAbsoluteUrl/* default */.Z)(backButton.href, pageConfig),
            iconStart: Common/* ChevronLeftIcon */.wy,
            children: backButton.text
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledOverline, {
            tag: "h5",
            variant: "overline",
            children: episode
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: episodeTitle
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: episodeDescription
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroRecipeContents, {
        children: episodeImage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
          alt: String(episodeImage === null || episodeImage === void 0 ? void 0 : episodeImage.alt),
          src: String(episodeImage === null || episodeImage === void 0 ? void 0 : episodeImage.src),
          width: episodeImage === null || episodeImage === void 0 ? void 0 : episodeImage.width,
          height: episodeImage === null || episodeImage === void 0 ? void 0 : episodeImage.height
        })
      })]
    })
  });
};

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "eqblmhy5"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";padding-top:40px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:80px;}" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "eqblmhy4"
} : 0)(recipes_Hero/* Wrapper */.im, "{padding-top:0;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{grid-template-columns:56% 34.5%;}}" + ( true ? "" : 0));

var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "eqblmhy3"
} : 0)( true ? {
  name: "g46w8s",
  styles: "margin-bottom:30px"
} : 0);

var StyledHeroRecipeContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Contents */.AU,  true ? {
  target: "eqblmhy2"
} : 0)( true ? {
  name: "1qvwt2v",
  styles: "min-width:auto"
} : 0);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "eqblmhy1"
} : 0)("max-width:200px;margin:0;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("sm");
}, "{max-width:260px;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:100%;}" + ( true ? "" : 0));

var StyledOverline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "eqblmhy0"
} : 0)( true ? {
  name: "4jdan2",
  styles: "text-transform:none;letter-spacing:0px"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/assets/OgPodcastHub.jpeg
var OgPodcastHub = __webpack_require__(37545);
var OgPodcastHub_default = /*#__PURE__*/__webpack_require__.n(OgPodcastHub);
;// CONCATENATED MODULE: ./src/views/GoodDataBetterMarketing/SinglePage/GoodDataBetterMarketingPodcast.tsx



function GoodDataBetterMarketingPodcast_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GoodDataBetterMarketingPodcast_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GoodDataBetterMarketingPodcast_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GoodDataBetterMarketingPodcast_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var GoodDataBetterMarketingPodcast = function GoodDataBetterMarketingPodcast(_ref) {
  var _data$episodeHeroImag7, _data$episodeHeroImag8, _data$episodeHeroImag9, _data$episodeHeroImag10, _data$episodeHeroImag11, _data$episodeHeroImag12, _data$socialTitle;

  var episodeSlug = _ref.episodeSlug;

  var _useEpisodeQuery = (0,queries/* useEpisodeQuery */.cA)({
    args: [episodeSlug]
  }),
      data = _useEpisodeQuery.data;

  if (!data) throw new Error("Episode data is missing. Make sure it's preloaded");
  var contentHeadingsOptions = (0,react.useMemo)(function () {
    return [data.speakerBio && {
      text: "Guest Speaker",
      value: "guest-speaker"
    }, data.episodeSummary && {
      text: "Episode Summary",
      value: "episode-summary"
    }, data.keyTakeaways && {
      text: "Key Takeaways",
      value: "key-takeaways"
    }, data.speakerQuotes && {
      text: "Speaker Quotes",
      value: "speaker-quotes"
    }, data.episodeTimestamps && {
      text: "Episode Timestamps",
      value: "episode-timestamps"
    }, data.resourcesLinks && {
      text: "Resources & Links",
      value: "resources-and-links"
    }, data.transcript && {
      text: "Read the Transcript",
      value: "read-the-transcript"
    }];
  }, [data.episodeSummary, data.episodeTimestamps, data.keyTakeaways, data.resourcesLinks, data.speakerBio, data.speakerQuotes, data.transcript]);
  var articleSections = (0,react.useMemo)(function () {
    return [{
      heading: "Guest speaker: ".concat(data.speakerName),
      content: data.speakerBio,
      id: "guest-speaker"
    }, {
      heading: "Episode summary",
      content: data.episodeSummary,
      id: "episode-summary"
    }, {
      heading: "Key takeaways",
      content: data.keyTakeaways,
      id: "key-takeaways"
    }, {
      heading: "Speaker quotes",
      content: data.speakerQuotes,
      id: "speaker-quotes"
    }, {
      heading: "Episode timestamps",
      content: data.episodeTimestamps,
      id: "episode-timestamps"
    }, {
      heading: "Resources & links",
      content: data.resourcesLinks,
      id: "resources-and-links"
    }];
  }, [data.episodeSummary, data.episodeTimestamps, data.keyTakeaways, data.resourcesLinks, data.speakerBio, data.speakerName, data.speakerQuotes]);
  var heroData = (0,react.useMemo)(function () {
    var _data$episodeHeroImag, _data$episodeHeroImag2, _data$episodeHeroImag3, _data$episodeHeroImag4, _data$episodeHeroImag5, _data$episodeHeroImag6;

    return {
      episodeNumber: data.episodeNumber,
      episodeTitle: data.episodeTitle,
      episodeDescription: data.episodeDescription,
      episodeImage: {
        src: (_data$episodeHeroImag = data.episodeHeroImage) === null || _data$episodeHeroImag === void 0 ? void 0 : _data$episodeHeroImag.fields.file.url,
        width: (_data$episodeHeroImag2 = data.episodeHeroImage) === null || _data$episodeHeroImag2 === void 0 ? void 0 : (_data$episodeHeroImag3 = _data$episodeHeroImag2.fields.file.details.image) === null || _data$episodeHeroImag3 === void 0 ? void 0 : _data$episodeHeroImag3.width,
        height: (_data$episodeHeroImag4 = data.episodeHeroImage) === null || _data$episodeHeroImag4 === void 0 ? void 0 : (_data$episodeHeroImag5 = _data$episodeHeroImag4.fields.file.details.image) === null || _data$episodeHeroImag5 === void 0 ? void 0 : _data$episodeHeroImag5.height,
        alt: (_data$episodeHeroImag6 = data.episodeHeroImage) === null || _data$episodeHeroImag6 === void 0 ? void 0 : _data$episodeHeroImag6.fields.description
      }
    };
  }, [data.episodeDescription, (_data$episodeHeroImag7 = data.episodeHeroImage) === null || _data$episodeHeroImag7 === void 0 ? void 0 : _data$episodeHeroImag7.fields.description, (_data$episodeHeroImag8 = data.episodeHeroImage) === null || _data$episodeHeroImag8 === void 0 ? void 0 : (_data$episodeHeroImag9 = _data$episodeHeroImag8.fields.file.details.image) === null || _data$episodeHeroImag9 === void 0 ? void 0 : _data$episodeHeroImag9.height, (_data$episodeHeroImag10 = data.episodeHeroImage) === null || _data$episodeHeroImag10 === void 0 ? void 0 : (_data$episodeHeroImag11 = _data$episodeHeroImag10.fields.file.details.image) === null || _data$episodeHeroImag11 === void 0 ? void 0 : _data$episodeHeroImag11.width, (_data$episodeHeroImag12 = data.episodeHeroImage) === null || _data$episodeHeroImag12 === void 0 ? void 0 : _data$episodeHeroImag12.fields.file.url, data.episodeNumber, data.episodeTitle]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: (_data$socialTitle = data.socialTitle) !== null && _data$socialTitle !== void 0 ? _data$socialTitle : "",
      pageDescription: data.socialDescription,
      pageOG: (OgPodcastHub_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
        appearance: "dark",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, GoodDataBetterMarketingPodcast_objectSpread({}, heroData)), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
            variant: "sidebar",
            sidebarSize: "small",
            sticky: true,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Sidebar */.YE, {
              as: "aside",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Sticky */.Le, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Sidebar_Sidebar, {
                  id: "article-sidebar",
                  data: contentHeadingsOptions
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentsInner, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EpisodePlayers_EpisodePlayers, {
                  simplecastId: data.simplecastId,
                  applePodcastsUrl: data.applePodcastsUrl,
                  googlePodcastsUrl: data.googlePodcastsUrl,
                  spotifyUrl: data.spotifyUrl
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleContent_ArticleContent, {
                  sections: articleSections
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Transcript_Transcript, {
                  heading: "Read the transcript",
                  id: "read-the-transcript",
                  content: data.transcript
                })]
              })
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecentEpisodes_RecentEpisodes, {
          episodeSlug: episodeSlug
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LearnFromVeryBest/* default */.Z, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1lqsbfr2"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var ContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lqsbfr1"
} : 0)("background:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.neutrals.white[100];
}, ";", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

var ContentsInner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lqsbfr0"
} : 0)("display:grid;gap:20px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("md");
}, "{gap:56px;}" + ( true ? "" : 0));

/* harmony default export */ var SinglePage_GoodDataBetterMarketingPodcast = (GoodDataBetterMarketingPodcast);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/good-data-better-marketing/[slug].tsx


function _slug_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _slug_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _slug_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _slug_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var GoodDataBetterMarketingPage = function GoodDataBetterMarketingPage(props) {
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SinglePage_GoodDataBetterMarketingPodcast, _slug_objectSpread({}, props))
  });
};

var __N_SSG = true;
/* harmony default export */ var _slug_ = (GoodDataBetterMarketingPage);

/***/ }),

/***/ 36590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_components_ColumnTrack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85735);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74870);
/* harmony import */ var _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6580);
/* harmony import */ var _segment_matcha_components_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16154);
/* harmony import */ var _segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88392);
/* harmony import */ var _segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94136);
/* harmony import */ var _segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74881);
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43848);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52903);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var copy = {
  heading: "Learn from very best across every industry",
  description: "We distilled the best tips, tricks & trends from our guests for you. Learn how to power your customer engagement strategies with a strong data foundation."
};
var cardData = [{
  href: "https://learn.segment.com/customer-engagement-tactics/",
  badge: "Guide",
  title: "How Top Brands from IBM to PepsiCo Use Data to Strengthen Customer Relationships",
  description: "To provide memorable experiences, businesses must use proven tactics to engage customers. Learn how top brands are focusing on customer engagement to build stronger relationships.",
  action: "Read the guide"
}, {
  href: "/learn/download/ai-powered-personalization/",
  badge: "Ebook",
  title: "Personalization in the Age of AI: How 4 Brands are Shaping the Future",
  description: "Learn how AI-powered personalization is reshaping the customer experience, and how four leading brands (Instacart, Nextdoor, Saks, and Amazon) are using it to improve customer engagement and drive growth.",
  action: "Read the ebook"
}];

var LearnFromVeryBest = function LearnFromVeryBest() {
  var pageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_8__/* .usePageConfig */ .Gm)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
    variant: "centered",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_5__/* .Copy */ .CK, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        centered: true,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_6__/* .Heading */ .X6, {
          tag: "h2",
          children: copy.heading
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_6__/* .Description */ .dk, {
          tag: "p",
          variant: "pLarge",
          children: copy.description
        })]
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_5__/* .Contents */ .AU, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(StyledColumnTrack, {
        "aria-live": "polite",
        columns: 1,
        overrides: {
          md: 2,
          xl: cardData.length
        },
        center: true,
        length: cardData.length,
        children: cardData && cardData.map(function (data) {
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            href: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(data.href, pageConfig),
            layout: "vertical",
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_7__/* .Accessories */ .v8, {
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_7__/* .AccessoriesRow */ .OW, {
                  children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_components_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: "outlined",
                    children: data.badge
                  })
                })
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_7__/* .Copy */ .CK, {
                children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_7__/* .Headline */ .s0, {
                  tag: "h3",
                  children: data.title
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_7__/* .Description */ .dk, {
                  variant: "pLarge",
                  children: data.description
                })]
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_7__/* .Action */ .aU, {
                alignment: "left",
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                  iconEnd: _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_3__/* .ChevronRightIcon */ .XC,
                  children: data.action
                })
              })]
            })
          }, data.title);
        })
      })
    })]
  });
};

var _ref =  true ? {
  name: "1qo2gge",
  styles: "max-width:896px;margin:0 auto"
} : 0;

var StyledColumnTrack = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_ColumnTrack__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,  true ? {
  target: "e14ht4ro0"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{", function (_ref3) {
  var length = _ref3.length;
  return length <= 2 && _ref;
}, ";}" + ( true ? "" : 0));

/* harmony default export */ __webpack_exports__["Z"] = (LearnFromVeryBest);

/***/ }),

/***/ 19890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cA": function() { return /* reexport */ useEpisodeQuery; },
  "md": function() { return /* reexport */ useFetchGDBMDataQuery; },
  "Oh": function() { return /* reexport */ useRecentEpisodeQuery; }
});

// UNUSED EXPORTS: createEpisodeQuery, createFetchGDBMDataQuery, createRecentEpisodesQuery, fetchAllEpisodesSlugs, fetchFeaturedGDBMData, fetchGDBMData, fetchRecentEpisodesData

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utils/createInfinityQueryHook/createInfinityQueryHook.ts
var createInfinityQueryHook = __webpack_require__(99338);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ../../libs/api/routes/goodDataBetterMarketing/queries/goodDataBetterMarketingDataQuery.ts
/* provided dependency */ var process = __webpack_require__(34406);





var DEFAULT_LIMIT = 3;
var DEFAULT_OFFSET = 0;
var fetchFeaturedGDBMData = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var enabled, filterParams, cachedFetch;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            filterParams = new URLSearchParams();
            filterParams.set("fields.featuredEpisode", "true");
            filterParams.set("order", "-fields.episodeNumber");
            _context.next = 6;
            return createFsCacheProxy(["goodDataBetterMarketing/goodDataBetterMarketingDataFeaturedQuery", filterParams.toString()], function () {
              return client.get("/content/entries/podcastEpisode?".concat(filterParams.toString())).then(function (data) {
                return data !== null && data !== void 0 && data.length ? data[0] : null;
              });
            }, {
              enabled: enabled
            });

          case 6:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFeaturedGDBMData(_x) {
    return _ref.apply(this, arguments);
  };
}()));
var fetchGDBMData = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client) {
    var pagination,
        enabled,
        _pagination$offset,
        offset,
        _pagination$limit,
        limit,
        searchParams,
        cachedFetch,
        _args2 = arguments;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            pagination = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _pagination$offset = pagination.offset, offset = _pagination$offset === void 0 ? DEFAULT_OFFSET : _pagination$offset, _pagination$limit = pagination.limit, limit = _pagination$limit === void 0 ? DEFAULT_LIMIT : _pagination$limit;
            searchParams = new URLSearchParams();
            searchParams.set("limit", limit.toString());
            searchParams.set("offset", offset.toString());
            _context2.next = 8;
            return (0,fsCache/* createFsCacheProxy */.c)(["goodDataBetterMarketing/goodDataBetterMarketingDataQuery", searchParams.toString()], function () {
              return client.get("/content/filter/podcastEpisodes?".concat(searchParams.toString())).then(function (data) {
                return data.items.length ? data : null;
              });
            }, {
              enabled: enabled
            });

          case 8:
            cachedFetch = _context2.sent;
            return _context2.abrupt("return", cachedFetch());

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchGDBMData(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var createFetchGDBMDataQuery = function createFetchGDBMDataQuery(client) {
  return [["goodDataBetterMarketing", "goodDataBetterMarketingDataQuery"], /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref3) {
      var _ref3$pageParam, pagination, data;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref3$pageParam = _ref3.pageParam, pagination = _ref3$pageParam === void 0 ? {} : _ref3$pageParam;
              _context3.next = 3;
              return fetchGDBMData(client, pagination);

            case 3:
              data = _context3.sent;
              return _context3.abrupt("return", data);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }()];
};
var useFetchGDBMDataQuery = (0,createInfinityQueryHook/* default */.Z)(createFetchGDBMDataQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    if (!p) return;
    var nextOffset = p.skip - p.limit;

    if (nextOffset < 0) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  },
  getNextPageParam: function getNextPageParam(p) {
    if (!p) return;
    var nextOffset = p.skip + p.limit;

    if (p.total <= nextOffset) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  }
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
;// CONCATENATED MODULE: ../../libs/api/routes/goodDataBetterMarketing/queries/goodDataBetterMarketingPodcastQuery.ts
/* provided dependency */ var goodDataBetterMarketingPodcastQuery_process = __webpack_require__(34406);




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var fetchAllEpisodes = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client) {
    var enabled, fetchWithCache, data;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            enabled = Boolean(goodDataBetterMarketingPodcastQuery_process.env.ENABLE_FS_CACHE);
            _context2.next = 3;
            return (0,fsCache/* createFsCacheProxy */.c)(["goodDataBetterMarketing/episodes"], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
              var rawResponse, description, nonEmptyData;
              return regenerator_default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return client.get("/content/filter/podcastEpisodes");

                    case 2:
                      rawResponse = _context.sent;

                      if (rawResponse.items) {
                        _context.next = 7;
                        break;
                      }

                      description = rawResponse.toString();

                      if (typeof rawResponse === "object" && !Array.isArray(rawResponse) && rawResponse !== null) {
                        description = "Object with ".concat(Object.keys(rawResponse));
                      }

                      throw new Error("Got malformed response. Expected object with items property. Got ".concat(description));

                    case 7:
                      nonEmptyData = _objectSpread(_objectSpread({}, rawResponse), {}, {
                        items: rawResponse.items.filter(function (i) {
                          return i;
                        })
                      });
                      return _context.abrupt("return", nonEmptyData);

                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })), {
              enabled: enabled
            });

          case 3:
            fetchWithCache = _context2.sent;
            _context2.next = 6;
            return fetchWithCache();

          case 6:
            data = _context2.sent;
            return _context2.abrupt("return", data);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllEpisodes(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchAllEpisodesSlugs = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client) {
    var allEpisodes;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchAllEpisodes(client);

          case 2:
            allEpisodes = _context3.sent;
            return _context3.abrupt("return", allEpisodes === null || allEpisodes === void 0 ? void 0 : allEpisodes.items.map(function (i) {
              var _i$fields;

              return i === null || i === void 0 ? void 0 : (_i$fields = i.fields) === null || _i$fields === void 0 ? void 0 : _i$fields.slug;
            }));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchAllEpisodesSlugs(_x2) {
    return _ref3.apply(this, arguments);
  };
}()));
var createEpisodeQuery = function createEpisodeQuery(client, episodeSlug) {
  return [["goodDataBetterMarketing/episodeQuery", episodeSlug], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var _allEpisodes$items$fi, allEpisodes, episodeData;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetchAllEpisodes(client);

          case 3:
            allEpisodes = _context4.sent;
            episodeData = (_allEpisodes$items$fi = allEpisodes.items.find(function (s) {
              return s.fields.slug === episodeSlug;
            })) === null || _allEpisodes$items$fi === void 0 ? void 0 : _allEpisodes$items$fi.fields;

            if (episodeData) {
              _context4.next = 7;
              break;
            }

            throw new Error("Episode data is empty");

          case 7:
            return _context4.abrupt("return", episodeData);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to find episode with ".concat(episodeSlug, ".\nUnderlying error: ").concat(_context4.t0));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 10]]);
  }))];
};
var useEpisodeQuery = (0,createQueryHook/* default */.Z)(createEpisodeQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
var fetchRecentEpisodesData = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(client) {
    var enabled, offset, limit, searchParams, cachedFetch;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            enabled = Boolean(goodDataBetterMarketingPodcastQuery_process.env.ENABLE_FS_CACHE);
            offset = 0;
            limit = 4;
            searchParams = new URLSearchParams();
            searchParams.set("limit", limit.toString());
            searchParams.set("offset", offset.toString());
            _context5.next = 8;
            return (0,fsCache/* createFsCacheProxy */.c)(["goodDataBetterMarketing/recentEpisodesDataQuery"], function () {
              return client.get("/content/filter/podcastEpisodes?".concat(searchParams.toString())).then(function (data) {
                return data.items.length ? data : null;
              });
            }, {
              enabled: enabled
            });

          case 8:
            cachedFetch = _context5.sent;
            return _context5.abrupt("return", cachedFetch());

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchRecentEpisodesData(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
var createRecentEpisodesQuery = function createRecentEpisodesQuery(client, episodeSlug) {
  return [["goodDataBetterMarketing/recentEpisodesQuery", episodeSlug], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
    var recentEpisodes, data;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetchRecentEpisodesData(client);

          case 3:
            recentEpisodes = _context6.sent;
            data = recentEpisodes === null || recentEpisodes === void 0 ? void 0 : recentEpisodes.items.filter(function (_ref7) {
              var fields = _ref7.fields;
              return fields.slug !== episodeSlug;
            }).slice(0, 3);

            if (data) {
              _context6.next = 7;
              break;
            }

            throw new Error("Recent episodes data is empty");

          case 7:
            return _context6.abrupt("return", data);

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](0);
            console.error("Failed to load recent episodes.\nUnderlying error: ".concat(_context6.t0));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 10]]);
  }))];
};
var useRecentEpisodeQuery = (0,createQueryHook/* default */.Z)(createRecentEpisodesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/goodDataBetterMarketing/queries/index.ts



/***/ }),

/***/ 83914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body_Body; },
  "vs": function() { return /* reexport */ ContentWrapper_ContentWrapper; },
  "h4": function() { return /* reexport */ Accordion_Header_Header; },
  "JO": function() { return /* reexport */ Icon_Icon; },
  "yD": function() { return /* reexport */ JsonLdFaq; },
  "DK": function() { return /* reexport */ Accordion_SubTitle_SubTitle; },
  "xv": function() { return /* reexport */ Accordion_Text_Text; },
  "Dx": function() { return /* reexport */ Accordion_Title_Title; },
  "$t": function() { return /* reexport */ TitleWrapper_TitleWrapper; },
  "ZP": function() { return /* reexport */ Accordion_Base_Base; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var VerticalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u2"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";opacity:", function (_ref2) {
  var opacity = _ref2.opacity;
  return opacity;
}, ";width:2px;height:12px;transition:300ms background,300ms opacity;position:absolute;top:0;left:5px;" + ( true ? "" : 0));
var HorizontalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u1"
} : 0)("background:", function (_ref3) {
  var background = _ref3.background;
  return background;
}, ";width:12px;height:2px;transition:300ms background;position:absolute;top:5px;left:0;" + ( true ? "" : 0));
var IconStyle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u0"
} : 0)( true ? {
  name: "xcbroa",
  styles: "width:12px;height:12px;position:relative"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.tsx


var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseIcon = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconStyle, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalLine, _objectSpread({}, tokens)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine, _objectSpread({}, tokens))]
  }));
});
var Icon = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIcon, function (_ref2) {
  var _ref2$opened = _ref2.opened,
      opened = _ref2$opened === void 0 ? false : _ref2$opened;
  return {
    opacity: opened ? 0 : 1
  };
}, {
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      background: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      background: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var opened = _ref5.opened;
    return {
      background: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Icon_Icon = (Icon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.views.ts

var Base = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejcpq100"
} : 0)("width:100%;border-bottom:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.tsx


var Base_excluded = ["children", "tokens"];

function Base_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Base_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Base_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var AccordionBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Base_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Base, Base_objectSpread(Base_objectSpread(Base_objectSpread({}, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Base_Base = (0,useDesignTokens/* withDesignTokens */.Y)(AccordionBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  }
});
/* harmony default export */ var Accordion_Base_Base = (Base_Base);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.views.ts


function Text_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1abg28t0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.tsx


var Text_excluded = ["children", "variant", "tokens"];

function Text_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Text_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Text_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseText = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pMedium" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Text_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, Text_objectSpread(Text_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Text_Text = (0,useDesignTokens/* withDesignTokens */.Y)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Text_Text = (Text_Text);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/index.ts

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Body/Body.tsx


var Body_excluded = ["children"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Body = function Body(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, Body_objectSpread(Body_objectSpread({}, rest), {}, {
    initial: false,
    children: children
  }));
};

/* harmony default export */ var Body_Body = (Body);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.views.ts


function ContentWrapper_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuwow0"
} : 0)( true ? {
  name: "1sk9ltb",
  styles: "padding-bottom:32px;overflow:hidden"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.tsx


var ContentWrapper_excluded = ["children"];

function ContentWrapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ContentWrapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ContentWrapper_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContentWrapper_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var ContentWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ContentWrapper_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: "auto"
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, ContentWrapper_objectSpread(ContentWrapper_objectSpread({
      ref: ref
    }, rest), {}, {
      children: children
    }))
  }, "content");
});
/* harmony default export */ var ContentWrapper_ContentWrapper = (ContentWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.views.ts


function Title_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "enok57o0"
} : 0)( true ? {
  name: "139xlyq",
  styles: "text-align:left;margin:16px 0;transition:300ms color"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.tsx


var Title_excluded = ["children", "variant", "tokens"];

function Title_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Title_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "h4" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, Title_objectSpread(Title_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Title_Title = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var opened = _ref2.opened;
    return {
      color: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      color: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      color: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Title_Title = (Title_Title);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.views.ts


function SubTitle_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var SubTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "elm17wd0"
} : 0)( true ? {
  name: "jhsf3s",
  styles: "text-align:left;margin:16px 0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.tsx


var SubTitle_excluded = ["children", "variant", "tokens"];

function SubTitle_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SubTitle_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SubTitle_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubTitle_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseSubTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pSmall" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SubTitle_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, SubTitle_objectSpread(SubTitle_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var SubTitle_SubTitle = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSubTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_SubTitle_SubTitle = (SubTitle_SubTitle);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/index.ts

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/JsonLdFaq.tsx


var JsonLdFaq = function JsonLdFaq(_ref) {
  var data = _ref.data;
  var entities = data.map(function (_ref2) {
    var question = _ref2.question,
        answer = _ref2.answer;
    return {
      '@type': "Question",
      name: question,
      acceptedAnswer: {
        '@type': "Answer",
        text: answer
      }
    };
  });
  var json = {
    '@context': "https://schema.org",
    '@type': "FAQPage",
    mainEntity: entities
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(json)
      }
    })
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/TitleWrapper.tsx


var TitleWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16ehyoi0"
} : 0)( true ? "" : 0);

/* harmony default export */ var TitleWrapper_TitleWrapper = (TitleWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.views.ts



var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eqrws8a0"
} : 0)("width:100%;display:grid;gap:28px;grid-template-columns:auto auto;align-items:center;justify-content:space-between;cursor:pointer;margin:12px 0;:hover{", Title, "{color:", function (_ref) {
  var hoverTitleColor = _ref.hoverTitleColor;
  return hoverTitleColor;
}, ";}", HorizontalLine, ",", VerticalLine, "{background-color:", function (_ref2) {
  var hoverIconBackgroundColor = _ref2.hoverIconBackgroundColor;
  return hoverIconBackgroundColor;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.tsx


var Header_excluded = ["children", "onClick", "tokens"];

function Header_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Header_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Header_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Header_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var HeaderBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Header_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, Header_objectSpread(Header_objectSpread(Header_objectSpread({
    onClick: onClick
  }, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Header_Header = (0,useDesignTokens/* withDesignTokens */.Y)(HeaderBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      hoverTitleColor: theme.palette.brand.segmentGreen[500],
      hoverIconBackgroundColor: theme.palette.brand.segmentGreen[500]
    };
  },
  light: function light(theme) {
    return {
      hoverTitleColor: theme.palette.brand.boysenberry[500],
      hoverIconBackgroundColor: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      hoverTitleColor: theme.palette.twilio.blue[60],
      hoverIconBackgroundColor: theme.palette.twilio.blue[60]
    };
  }
});
/* harmony default export */ var Accordion_Header_Header = (Header_Header);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/index.ts










Accordion_Base_Base.displayName = "AccordionBase";
Accordion_Header_Header.displayName = "Accordion.Header";
Body_Body.displayName = "Accordion.Body";
Accordion_Text_Text.displayName = "Accordion.Text";
Accordion_Title_Title.displayName = "Accordion.Title";
Accordion_SubTitle_SubTitle.displayName = "Accordion.SubTitle";
TitleWrapper_TitleWrapper.displayName = "Accordion.TitleWrapper";
ContentWrapper_ContentWrapper.displayName = "Accordion.ContentWrapper";
Icon_Icon.displayName = "Accordion.Icon";
JsonLdFaq.displayName = "Accordion.JsonLdFaq";


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 99338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58586);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates infinite query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useInfiniteQuery
 */

var createInfiniteQueryHook = function createInfiniteQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery.apply */ .N.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createInfiniteQueryHook);

/***/ }),

/***/ 74864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useActiveState; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/useActiveState.tsx



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var DEFAULT_OPTIONS = {
  allowMultipleActive: false,
  minActive: 0
};
/**
 * A hook that provides a stateful array of booleans and functions to toggle, enable and disable them.
 * @param initialState The initial state of the array of booleans.
 * @param options Options to configure the hook.
 * @returns The stateful array of booleans and functions to toggle, enable and disable them.
 */

var useActiveState = function useActiveState(initialState, options) {
  var _useState = (0,react.useState)(initialState),
      activeItems = _useState[0],
      setActiveItems = _useState[1];

  var settings = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var toggle = function toggle(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (items[index]) {
      var activeItemsLength = items.filter(function (item) {
        return item;
      }).length;

      if (activeItemsLength > settings.minActive) {
        items[index] = false;
      }
    } else {
      if (!settings.allowMultipleActive) {
        items = new Array(items.length).fill(false);
      }

      items[index] = true;
    }

    setActiveItems(items);
  };

  var enable = function enable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (!settings.allowMultipleActive) {
      items = new Array(items.length).fill(false);
    }

    items[index] = true;
    setActiveItems(items);
  };

  var disable = function disable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    var activeItemsLength = items.filter(function (item) {
      return item;
    }).length;

    if (activeItemsLength > settings.minActive) {
      items[index] = false;
      setActiveItems(items);
    }
  };

  return {
    activeItems: activeItems,
    setActiveItems: setActiveItems,
    toggle: toggle,
    enable: enable,
    disable: disable
  };
};
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/index.ts


/***/ }),

/***/ 2636:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/good-data-better-marketing/[slug]",
      function () {
        return __webpack_require__(15611);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37545:
/***/ (function(module) {

module.exports = "/_next/static/images/OgPodcastHub-c8cdb9d2bf4f920ef5f40aa3a2b0f436.jpeg";

/***/ }),

/***/ 58586:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(36370);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/queryObserver.mjs
var queryObserver = __webpack_require__(91578);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(54388);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/query-core/build/lib/infiniteQueryObserver.mjs



class InfiniteQueryObserver extends queryObserver/* QueryObserver */.z {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }

  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }

  setOptions(options, notifyOptions) {
    super.setOptions({ ...options,
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }, notifyOptions);
  }

  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }

  fetchNextPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam
        }
      }
    });
  }

  fetchPreviousPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam
        }
      }
    });
  }

  createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    const {
      state
    } = query;
    const result = super.createResult(query, options);
    return { ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    };
  }

}


//# sourceMappingURL=infiniteQueryObserver.mjs.map

// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs + 4 modules
var useBaseQuery = __webpack_require__(53997);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs



function useInfiniteQuery(arg1, arg2, arg3) {
  const options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return (0,useBaseQuery/* useBaseQuery */.r)(options, InfiniteQueryObserver);
}


//# sourceMappingURL=useInfiniteQuery.mjs.map


/***/ }),

/***/ 95922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64034);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17602);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57211);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42330);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8943,1382,4136,2073,8392,5735,2429,7303,948,8187,3996,7947,7960,6012,4881,6818,5979,9774,2888,179], function() { return __webpack_exec__(2636); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);